export const title = 'Average ticket';

Average sales ticket.
